import { LaravelResponse } from "@dgs/core";
import axios from "axios";
import {
	HotelResource,
	HotelStayConfigurationRequest,
	HotelSummaryRequest,
	HotelSummaryResource,
	HotelsByDateRangeRequest,
	StayConfigurationResource,
} from "../types/hotel";

export const hotelSectionService = {
	stayConfigurationKey: (sectionId: number, request: HotelStayConfigurationRequest) => [
		"hotel-sections",
		sectionId,
		"stay-configuration",
		request,
	],
	getHotels: (sectionId: number, request: HotelsByDateRangeRequest) =>
		axios.get<LaravelResponse<HotelResource[]>>(`hotel-sections/${sectionId}/hotels`, {
			params: {
				...request,
				guestId: request.guestId ?? undefined,
			},
		}),
	getStayConfiguration: (sectionId: number, request: HotelStayConfigurationRequest) =>
		axios
			.get<LaravelResponse<StayConfigurationResource | undefined>>(`hotel-sections/${sectionId}/stay-configuration`, {
				params: {
					...request,
					guestId: request.guestId ?? undefined,
				},
			})
			.then((response) => response.data.data ?? null),
	hotelSummaryKey: (sectionId: number, request: HotelSummaryRequest) => [
		"hotel-sections",
		sectionId,
		"hotel-summary",
		request,
	],
	getHotelSummary: (sectionId: number, request: HotelSummaryRequest) =>
		axios
			.put<LaravelResponse<HotelSummaryResource[]>>(`hotel-sections/${sectionId}/hotel-summary`, request)
			.then((response) => response.data.data),
};
